import { io } from 'socket.io-client';

// One shared socket for the whole admin panel. The server pushes "adminRefresh" whenever something an admin should
// notice happens (a contact or support message, a sign-up, a profile-option suggestion), so counts and inboxes update
// at once. The 10-30 second polling elsewhere stays as the fallback if the socket is down.
const apiBase = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const origin = apiBase.replace(/\/api\/?$/, '');

let socket = null;
const listeners = new Set();

const connect = () => {
    if (socket) return;
    socket = io(origin, { transports: ['websocket', 'polling'], reconnection: true });
    const join = () => {
        const token = localStorage.getItem('adminToken');
        if (token) socket.emit('joinAdmin', token);
    };
    socket.on('connect', join); // also runs again after every reconnect
    // Many events in a row (e.g. a bulk update) become ONE refresh a moment later, so the panel never floods the API.
    let timer = null;
    socket.on('adminRefresh', () => {
        if (timer) return;
        timer = setTimeout(() => {
            timer = null;
            listeners.forEach(fn => { try { fn(); } catch (e) { /* one listener must not stop the others */ } });
        }, 1500);
    });
};

// Returns an unsubscribe function.
export const onAdminRefresh = (fn) => {
    connect();
    listeners.add(fn);
    return () => listeners.delete(fn);
};
